<template>
  <div id="cropper">
    <v-dialog v-model="dialog" persistent max-width="750">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col>
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <span v-show="imageData">Editar</span>
              <span v-show="!imageData">Adicionar</span>
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <v-card>
        <v-card-title class="header-crop headline" justify="center">{{ title }}</v-card-title>
        <cropper
          :src="imageData"
          ref="cropper"
        />
        <div class="button-wrapper">
          <span class="button" @click="$refs.file.click()">
            <input type="file" ref="file" @change="loadImage($event)" accept="image/*">
            Carregar imagem da logo
          </span>
          <button @click="crop" class="button">
            Cortar imagem
          </button>
        </div>
        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="emitImageEvent();">
            Finalizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <img class="image-logo" :src="imageData ? imageData : noImage" />
  </div>
</template>


<script>
// import VImageInput from 'vuetify-image-input';
import { defaultImageLogo } from '@/const/image/defaultImage';

export default {
  name: "ImageCropper",
  props: [
    'title',
    'imageData'
  ],
  components: {
    // [VImageInput.name]: VImageInput,
  },
  data: () => ({
    dialog: false,
    noImage: defaultImageLogo
  }),
  methods: {
    emitImageEvent() {
      this.dialog = false;
      this.$emit( 'setImageEvent', this.imageData );
    },
    reset() {
      this.imageData = null;
    },
    loadImage(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    crop() {
      const { coordinates, canvas, } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image, that can be used 
      // as src for <img/> to preview result
      this.imageData = canvas.toDataURL();
    },
  }
}
</script>

<style scoped>
  .header-crop {
    background: #20c09e;
    color: azure;
  }

  .image-logo {
    width: 100%;
    height: 100%;
    border: solid 1px #d3d3d3;
    background-color: #ffffff;

  }

  .image-crop {
    margin-left: 20%;
    margin-top: 6%;
  }

  .image-front {
    height: auto;
    width: 100%;
    border: solid 1px #d3d3d3;
    background-color: #ffffff;
  }

  #cropper button {
    border-radius: 0;
    margin: 0 0 10px;
    height: 34px;
    font-size: 12px;
  }



  .upload-example-cropper {
    border: solid 1px #EEE;
    height: 300px;
    width: 100%;
  }

  .button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
  }

  .button {
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #3fb37f;
    cursor: pointer;
    transition: background 0.5s;
  }

  .button:hover {
    background: #38d890;
  }

  .button input {
    display: none;
  }
</style>




// WEBPACK FOOTER //
// src/components/form/formField/ImageCropper.vue